import { SealineNameDTO } from "../api/response.types";
import { SeaStatusesModel } from "entities/shared/seaCard.types";
import { ValueOf } from "shared/lib/typeCheck.lib";

export type SealineNameModel = SealineNameDTO;

export type CountBySeaStatusModel = {
  status: ValueOf<typeof SeaStatusesModel>;
  count: number;
};
